import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'
import { forwardRef } from 'react'
import { CARD_FRAME_CLASSNAME, CARD_PADDING_CLASSNAME } from 'shared/constants/card-class-names'
import { twMerge } from 'tailwind-merge'

type FunnelTabCardProps = useRender.ComponentProps<'section'>

const FunnelTabCard = forwardRef<HTMLElement, FunnelTabCardProps>(
  ({ className, render, ...props }, ref) =>
    useRender({
      defaultTagName: 'section',
      ref,
      render,
      props: mergeProps<'section'>(
        { className: twMerge(CARD_FRAME_CLASSNAME, CARD_PADDING_CLASSNAME, className) },
        props,
      ),
    }),
)

FunnelTabCard.displayName = 'FunnelTabCard'

export { FunnelTabCard }
export type { FunnelTabCardProps }
